import React from 'react';
import Navbar from '../components/Navbar';
import './Home.css';

function Home() {
  return (
    <div>
      <Navbar />
      <div className="hero-section">
        <div className="hero-content">
          <h1>Empowering Digital Defense with Innovation</h1>
          <p>Cloud Rhino delivers advanced cybersecurity solutions tailored for the evolving digital landscape, combining cutting-edge technology and expert insights.</p>
        </div>
      </div>
      <div className="main-content">
        <div className="introduction">
          <h2>About Cloud Rhino</h2>
          <p>Cloud Rhino is a forward-thinking cybersecurity company committed to protecting businesses against the most sophisticated cyber threats. Specializing in AI-driven solutions and custom cybersecurity software, our mission is to provide robust, adaptive, and reliable protection in an increasingly complex digital world.</p>
        </div>
        <div className="product-focus">
          <h2>Our Key Products</h2>
          <p>Our suite of products includes a custom NGINX-based Web Application Firewall (WAF), a secure Redis-Proxy, and an advanced Ingress Controller with built-in WAF capabilities. Each solution is designed to address specific security needs, from protecting web applications to securing cloud environments, all developed with a focus on performance and scalability.</p>
          <ul className="product-list">
            <li>NGINX-based WAF: A high-performance C++ module offering comprehensive protection against web threats.</li>
            <li>Redis-Proxy: A Go-based proxy enhancing security for Redis deployments in containerized environments.</li>
            <li>Custom Ingress Controller: A robust ingress solution with integrated WAF for Kubernetes, built on the latest NGINX core.</li>
            <li>Extended Infinity-Plus Datasource: Enhancing Grafana with secure MSI authentication for advanced data visualization.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Home;
